import apiRequest from '@/http/api-request'
import authService from '@/auth/authService'
import {prepareDonationParams} from "@/utils/utils";

export default {
  fetchAllDonations(tmp, {charityId}) {
    return apiRequest.doGetRequest(`/data/${charityId}/monthly`, {},
      {'X-Harness-JWT': authService.getToken()}, {skipCache: true})
  },
  fetchOneDonation(tmp, {charityId, subscriptionId}) {
    return apiRequest.doGetRequest(`/charity/${charityId}/monthly/${subscriptionId}`, {},
      {'X-Harness-JWT': authService.getToken()}, {skipCache: true})
  },
  editDonation(tmp, {charityId, subscriptionId, params}) {
    params = prepareDonationParams(params);
    return apiRequest.doPatchRequest(
      `/charity/${charityId}/monthly/${subscriptionId}`, 
      params,
      { 'Content-Type': 'application/json' },
    );
  },
  cancelDonation(tmp, {charityId, subscriptionId}) {
    return apiRequest.doDeleteRequest(`/charity/${charityId}/monthly/${subscriptionId}`);
  }
}
